import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { TextReplacementContent } from '@/pages/textCustomizations/components/TextReplacementContent';

const TextReplacements: PageWithLayout = () => {
    return (
        <>
            <Helmet>Textersetzungen | Starjack Admin</Helmet>

            <TextReplacementContent />
        </>
    );
};

TextReplacements.isProtected = true;
TextReplacements.getLayout = (Comp) => <SidebarLayout>{Comp}</SidebarLayout>;
TextReplacements.permissions = [Permission.TEXT_REPLACEMENT_NAV];

export default TextReplacements;
